<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">
                Relatório de Listagem de Contratos
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div ref="modal" class="ui large modal" style="top: 40px">
        <iframe
          ref="viewer"
          width="100%"
          style="height: calc(100vh - 100px)"
        ></iframe>
      </div>
      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div class="four wide field">
                  <label for="contract-report-format">Formato</label>
                  <select
                    id="contract-report-format"
                    class="ui dropdown"
                    v-model="form.format"
                  >
                    <option
                      v-for="(format, index) in formats"
                      :key="index"
                      :value="format.value"
                    >
                      {{ format.description }}
                    </option>
                  </select>
                </div>
              <div class="fields">
                <div class="four wide field">
                  <label for="cotract-by-collaborator-report-state">
                    Situação
                  </label>
                  <select
                    id="cotract-by-collaborator-report-state"
                    class="ui dropdown"
                    v-model="form.state"
                  >
                    <option
                      v-for="(state, index) in states"
                      :key="index"
                      :value="state.value"
                    >
                      {{ state.description }}
                    </option>
                  </select>
                </div>
                <div v-show="form.state === 'canceled'" class="four wide field">
                  <label for="contract-report-cancellation-origin">
                    Tipo de Cancelamento
                  </label>
                  <select
                    id="contract-report-cancellation-origin"
                    ref="cancellationOrigin"
                    class="ui dropdown"
                    v-model="form.cancellation_origin"
                  >
                    <option
                      v-for="(origin, index) in cancellationOrigins"
                      :key="index"
                      :value="origin.value"
                    >
                      {{ origin.description }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="ui field">
                <label for="">Data de Criação</label>
              </div>
              <div class="inline fields">
                <div
                  :class="['four wide', { error: errors.start_date }, 'field']"
                  :data-content="errorsTo('due_date')"
                >
                  <label for="cotract-by-collaborator-report-due-date"
                    >De:</label
                  >
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="cotract-by-collaborator-report-due-date"
                    v-model="form.start_date"
                  />
                </div>
                <div
                  :class="['four wide', { error: errors.end_date }, 'field']"
                  :data-content="errorsTo('end_date')"
                >
                  <label for="cotract-by-collaborator-report-date-of-payment"
                    >Até</label
                  >
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="cotract-by-collaborator-report-date-of-payment"
                    v-model="form.end_date"
                  />
                </div>
              </div>
              <div class="ui field">
                <label for="">Data de Cancelamento</label>
              </div>
              <div class="inline fields">
                <div
                  :class="[
                    'four wide',
                    { error: errors.canceled_at_start },
                    'field'
                  ]"
                  :data-content="errorsTo('canceled_at_start')"
                >
                  <label for="cotract-by-collaborator-report-canceled-start"
                    >De:</label
                  >
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="cotract-by-collaborator-report-canceled-start"
                    v-model="form.canceled_at_start"
                  />
                </div>
                <div
                  :class="[
                    'four wide',
                    { error: errors.canceled_at_end },
                    'field'
                  ]"
                  :data-content="errorsTo('canceled_at_end')"
                >
                  <label for="cotract-by-collaborator-report-canceled-at-end"
                    >Até</label
                  >
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="cotract-by-collaborator-report-canceled-at-end"
                    v-model="form.canceled_at_end"
                  />
                </div>
              </div>
              <div class="ui field">
                <label for="">Data de Inadimplência</label>
              </div>
              <div class="inline fields">
                <div
                  :class="[
                    'four wide',
                    { error: errors.overdue_at_start },
                    'field'
                  ]"
                  :data-content="errorsTo('overdue_at_start')"
                >
                  <label for="cotract-by-collaborator-report-overdue-start"
                    >De:</label
                  >
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="cotract-by-collaborator-report-overdue-start"
                    v-model="form.overdue_at_start"
                  />
                </div>
                <div
                  :class="[
                    'four wide',
                    { error: errors.overdue_at_end },
                    'field'
                  ]"
                  :data-content="errorsTo('overdue_at_end')"
                >
                  <label for="cotract-by-collaborator-report-overdue-at-end"
                    >Até</label
                  >
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="cotract-by-collaborator-report-overdue-at-end"
                    v-model="form.overdue_at_end"
                  />
                </div>
              </div>
              <div class="ui field">
                <label for="">Quantidade de Parcelas Atrasadas</label>
              </div>
              <div class="inline fields">
                <div class="four wide field">
                  <label for="contract-report-late-invoices-min">De:</label>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    id="contract-report-late-invoices-min"
                    v-model="form.late_invoices_min"
                  />
                </div>
                <div class="four wide field">
                  <label for="contract-report-late-invoices-max">Até</label>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    id="contract-report-late-invoices-max"
                    v-model="form.late_invoices_max"
                  />
                </div>
              </div>
              <div class="field">
                <label for="cotract-by-collaborator-report-collaborators">
                  Colaboradores
                </label>
                <select
                  id="cotract-by-collaborator-report-collaborators"
                  class="ui fluid search dropdown"
                  multiple=""
                  v-model="form.collaborators"
                >
                  <option
                    v-for="(collaborator, index) in collaborators"
                    :key="index"
                    :value="collaborator.id"
                  >
                    {{ collaborator.name }} - {{ collaborator.id }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label for="cotract-by-collaborator-report-plans">
                  Planos
                </label>
                <select
                  id="cotract-by-collaborator-report-plans"
                  class="ui fluid search dropdown"
                  multiple=""
                  v-model="form.plans"
                >
                  <option
                    v-for="(plan, index) in plans"
                    :key="index"
                    :value="plan.id"
                  >
                    {{ plan.description }} - {{ plan.id }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label for="cotract-by-collaborator-report-payment_methods">
                  Métodos de Pagamento
                </label>
                <select
                  id="cotract-by-collaborator-report-payment-methods"
                  class="ui fluid search dropdown"
                  multiple=""
                  v-model="form.payment_methods"
                >
                  <option
                    v-for="(payment_method, index) in paymentMethods"
                    :key="index"
                    :value="payment_method.name"
                  >
                    {{ payment_method.description }}
                  </option>
                </select>
              </div>
              <div class="field">
                <div class="ui checkbox">
                  <input
                    type="checkbox"
                    id="contract-report-upcoming-renewal"
                    v-model="form.upcomingRenewal"
                  />
                  <label for="contract-report-upcoming-renewal">
                    Completam ano este mês
                  </label>
                </div>
              </div>
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="run"
                  type="button"
                  name="run"
                  class="ui submit blue button"
                >
                  <i class="play icon"></i>Gerar Relatório
                </button>
              </div>
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import ContractEnum from '@/enumerations/contract_enum';
import { mapGetters } from 'vuex';

export default {
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      loaded: false,
      errors: {},
      collaborators: [],
      plans: [],
      formats: [
        { value: 'pdf', description: 'PDF' },
        { value: 'xls', description: 'Excel (XLS)' }
      ],
      form: {
        state: null,
        plans: [],
        payment_methods: [],
        collaborators: [],
        start_date: null,
        end_date: null,
        canceled_at_start: null,
        canceled_at_end: null,
        overdue_at_start: null,
        overdue_at_end: null,
        upcomingRenewal: false,
        cancellation_origin: null,
        late_invoices_min: null,
        late_invoices_max: null,
        format: 'pdf'
      },
      states: ContractEnum.states,
      cancellationOrigins: ContractEnum.cancellationOrigins
    };
  },

  computed: {
    anyError() {
      return !_.isEmpty(this.errors);
    },

    ...mapGetters({
      paymentMethods: 'settings/paymentMethods'
    })
  },

  watch: {
    'form.state'(state) {
      if (state !== 'canceled') {
        this.form.cancellation_origin = null;
        $(this.$refs.cancellationOrigin).dropdown('clear');
      }
    }
  },

  mounted() {
    this.getData();

    $('.ui.dropdown').dropdown();
    $('.ui.checkbox').checkbox();
  },

  methods: {
    async getData() {
      this.loading = true;

      const usersQuery = {
        all: true,
        q: {
          rule_eq: 'collaborator',
          s: ['name asc']
        }
      };

      const plansQuery = {
        q: {
          enable_eq: true,
          s: ['id asc']
        }
      };

      try {
        const usersResponse = await Api.users.search(usersQuery);
        this.collaborators = _.clone(usersResponse.data.users);

        const plansResponse = await Api.plans.search(plansQuery);
        this.plans = _.clone(plansResponse.data.plans);
      } catch (e) {
        this.$toast.show('Erro ao carregar dados', 'error');
        throw e;
      } finally {
        this.loading = false;
      }
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    download(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      }
    },

    run() {
      this.loading = true;
      let data = { report: 'contracts_list' };

      if (this.form.start_date && this.form.end_date) {
        data.CREATED_AT_START = this.$moment(
          this.form.start_date,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');

        data.CREATED_AT_END = this.$moment(
          this.form.end_date,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');
      }

      if (this.form.canceled_at_start && this.form.canceled_at_end) {
        data.CANCELED_AT_START = this.$moment(
          this.form.canceled_at_start,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');

        data.CANCELED_AT_END = this.$moment(
          this.form.canceled_at_end,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');
      }

      if (this.form.overdue_at_start && this.form.overdue_at_end) {
        data.OVERDUE_AT_START = this.$moment(
          this.form.overdue_at_start,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');

        data.OVERDUE_AT_END = this.$moment(
          this.form.overdue_at_end,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');
      }

      if (this.form.collaborators.length > 0) {
        data.COLLABORATOR_IDS = this.form.collaborators.join(',');
      }

      if (this.form.plans.length > 0) {
        data.PLAN_IDS = this.form.plans.join(',');
      }

      if (this.form.payment_methods.length > 0) {
        const covenants = this.form.payment_methods
          .map(x => `\\'${x}\\'`)
          .join(',');
        data.COVENANTS = covenants;

        let covenantsDescriptions = this.paymentMethods
          .filter(x => this.form.payment_methods.includes(x.name))
          .map(x => x.description)
          .join(',');

        data.COVENANTS_DESCRIPTIONS = `'${covenantsDescriptions}'`;
      }

      if (!_.isEmpty(this.form.state)) {
        data.STATUS_DESCRIPTION = this.states.find(
          state => state.value === this.form.state
        )?.description;
        data.STATUS = this.form.state;
      }

      if (
        this.form.state === 'canceled' &&
        !_.isEmpty(this.form.cancellation_origin)
      ) {
        data.CANCELLATION_ORIGIN = this.form.cancellation_origin;
      }

      const lateInvoicesMin = parseInt(this.form.late_invoices_min, 10);
      if (lateInvoicesMin >= 0) {
        data.LATE_INVOICES_MIN = lateInvoicesMin;
      }

      const lateInvoicesMax = parseInt(this.form.late_invoices_max, 10);
      if (lateInvoicesMax >= 0) {
        data.LATE_INVOICES_MAX = lateInvoicesMax;
      }

      if (this.form.upcomingRenewal) {
        data.UPCOMING_RENEWAL = 'true';
        data.UPCOMING_RENEWAL_DESCRIPTION = 'Sim';
      }

      data.report_type = this.form.format;

      Api.report(data)
        .then(response => {
          if (data.report_type === 'pdf') {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            $(this.$refs.viewer).attr('src', window.URL.createObjectURL(blob));
            $(this.$refs.modal).modal('show');
          } else {
            const blob = new Blob([response.data], {
              type: 'application/vnd.ms-excel'
            });
            this.download(blob, 'listagem_contratos.xls');
          }
        })
        .catch(error => {
          this.showError = true;
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
